module.exports = __webpack_public_path__ + "media/images/proof_links/colored/steam-0fb650bbcab732a9ac705df0c72a317a.svg";